import {service} from './service'
import {config} from './config'

const {default_headers} = config

const request = (option: any) => {
  const {url, method, params, data, headersType, responseType} = option

  // 代码无法上传文件，故注释
  // let serConfig = {
  //     url: url, method, params, data, responseType: responseType,
  //     headers: {
  //         'Content-Type': headersType || default_headers
  //     }
  // }

  // 如果是 FormData，不设置 Content-Type（浏览器自动处理）
  const headers = data instanceof FormData
    ? {} // 空 headers，让浏览器自动设置 Content-Type 和 boundary
    : {'Content-Type': headersType || default_headers}

  const serConfig = {
    url,
    method,
    params,
    data,
    responseType,
    headers: {
      ...headers,
      // 其他全局 headers（如 Authorization）可以在这里添加
    },
  }
  return service(serConfig)
}

export default {
  // post: <T = any>(option: any) => {   无法上传文件
  //
  //   /* 删除多余的字段 */
  //   if (option.data) {
  //
  //     const delKeys = ['updated_time', 'created_time', 'deleted_time']
  //     const columns = {...option.data}
  //
  //     for (const col in columns) {
  //       if (delKeys.indexOf(col) !== -1) {
  //         delete option.data[col]
  //       }
  //     }
  //   }
  //
  //   return request({method: 'post', ...option}) as unknown as T
  // },
  post: <T = any>(option: any) => {
    // 如果是 FormData，跳过数据清理逻辑
    if (!(option.data instanceof FormData)) {
      const delKeys = ['updated_time', 'created_time', 'deleted_time']
      if (option.data) {
        const columns = { ...option.data } // 普通对象可以解构

        for (const col in columns) {
          if (delKeys.includes(col)) {
            delete option.data[col]
          }
        }
      }
    }

    return request({ method: 'post', ...option }) as unknown as T
  },
}

/* 按约定，全部改用Post请求数据 */
// get: <T = any>(option: any) => {
//   return request({ method: 'get', ...option }) as unknown as T
// },
// delete: <T = any>(option: any) => {
//   return request({ method: 'delete', ...option }) as unknown as T
// },
// put: <T = any>(option: any) => {
//   return request({ method: 'put', ...option }) as unknown as T
// }
